import React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGIcon from 'components/svg-icon/SVGIcon';

import { t } from 'utils/language';

type Props = {
  campaignId: number,
  isCcm: boolean
};

const MessengerBrandBlankState = ({ campaignId, isCcm }: Props) => (
  <div className="messenger-brand-blank-state">
    <SVGIcon
      name="email-sent"
      width={240}
      height={160}
    />
    <p className="messenger-brand-blank-state__description">
      {t(`subcampaign_messenger.blank_state_description${isCcm ? '_ccm' : ''}`)}
    </p>
    <ActionButton link={`/campaigns${isCcm ? '/ccm' : ''}/${campaignId}/participants${isCcm ? '/accepted' : ''}`}>
      {t(`subcampaign_messenger.blank_state_action${isCcm ? '_ccm' : ''}`)}
    </ActionButton>
  </div>
);

export default MessengerBrandBlankState;
